import React, { useState, useEffect } from 'react';

const AnimatedScoreDisplay = ({ score = 91, title = "AI Ready", fontSize = "clamp(2rem, 8vw, 3.5rem)", showWheel = true ,animationOffset = 0}) => {
  const [animatedScore, setAnimatedScore] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    const duration = 2000; // 2 seconds
    const steps = 60;
    const increment = score / steps;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const currentScore = Math.min(increment * currentStep, score);
      setAnimatedScore(Math.round(currentScore));

      if (currentStep >= steps) {
        clearInterval(timer);
        setIsAnimating(false);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [score, animationOffset]);

  // Calculate the stroke dash array for the progress circle
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (animatedScore / 100) * circumference;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      aspectRatio: '1',
      padding: '20px',
      boxSizing: 'border-box',
      borderRadius: '24px',
      // backdropFilter: 'blur(10px)',
    //   border: showWheel ? '1px solid rgba(255, 255, 255, 0.1)' : 'none'
    }}>
      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '300px',
        aspectRatio: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        background: showWheel ? 'rgba(0, 0, 0, 0.1)' : 'none',

      }}>
        {showWheel && <svg
          width="100%"
          height="100%"
          viewBox="0 0 120 120"
          style={{ transform: 'rotate(-90deg)' }}
        >
          {/* Background circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke={showWheel ? "rgba(255, 255, 255, 0.1)" : "none"}
            strokeWidth="8"
          />
          
          {/* Gradient definitions */}
          <defs>
            <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="1%" stopColor="#88aff9" />
              <stop offset="50%" stopColor="#86d4fb" />
              <stop offset="100%" stopColor="#92fbfd" />
            </linearGradient>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur"/>
              <feOffset in="blur" dx="2" dy="2" result="offsetBlur"/>
              <feFlood floodColor="rgba(0, 0, 0, 0.5)" result="darkShadow"/>
              <feComposite in="darkShadow" in2="offsetBlur" operator="in" result="shadow"/>
              <feMerge> 
                <feMergeNode in="shadow"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Progress circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke="url(#progressGradient)"
            strokeWidth="16"
            strokeLinecap="square"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            filter="url(#glow)"
            style={{
              transition: 'stroke-dashoffset 0.1s ease-out'
            }}
          />
        </svg>}
        
        {/* Center content */}
        <div style={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--text-primary)',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            fontSize: fontSize,
            fontWeight: 'bold',
            lineHeight: 1,
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.3), 0 0 10px rgba(255, 255, 255, 0.2)'
          }}>
            {animatedScore}%
          </div>
          
          {/* Small progress bar under percentage */}
          <div style={{
            width: '40px',
            height: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '1px',
            marginTop: '8px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${animatedScore}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #7c3aed, #06b6d4, #10b981)',
              borderRadius: '1px',
              transition: 'width 0.1s ease-out'
            }} />
          </div>
        </div>
      </div>
      
      {/* Title text */}
      <div style={{
        marginTop: 'clamp(5px, 0vw, 10px)',
        fontSize: 'clamp(1.2rem, 4vw, 2rem)',
        fontWeight: '800',
        color: 'var(--text-primary)',
        textAlign: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        letterSpacing: '0.05em',
        textShadow: '0 0 10px rgba(255, 255, 255, 0.2)'
      }}>
        {title}
      </div>
    </div>
  );
};

export default AnimatedScoreDisplay;
